import { render } from "./BeyondTheCode.vue?vue&type=template&id=5f7c6fed&scoped=true"
import script from "./BeyondTheCode.vue?vue&type=script&lang=js"
export * from "./BeyondTheCode.vue?vue&type=script&lang=js"

import "./BeyondTheCode.vue?vue&type=style&index=0&id=5f7c6fed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7c6fed"]])

export default __exports__